// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__JytLc","name":"Header_name__drpps","birthday":"Header_birthday__1Hnx5","skeleton":"Header_skeleton__2tE6k"};